var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("h1", [_vm._v("Pricing Model")]),
      _c("div", { staticClass: "pricing-details mt-4" }, [
        _c("div", { staticClass: "pricing-item" }, [
          _c("div", { staticClass: "pricing-section transaction-fee" }, [
            _c("div", { staticClass: "left-side" }, [
              _c("h2", [_vm._v("Standard")]),
              _c("p", [
                _vm._v(
                  "Access a complete POS system with a simple, pay-as-you-go pricing. No setup fees, or hidden fees although you will need a device, either a laptop or tablet for each bar you wish to support."
                ),
              ]),
            ]),
            _c("div", { staticClass: "right-side" }, [
              _c("h2", [_vm._v("6% + $0.50")]),
              _c("p", [_vm._v("Per transaction on domestic cards")]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "pricing-item" }, [
          _c("div", { staticClass: "pricing-section transaction-fee" }, [
            _c("div", { staticClass: "left-side" }, [
              _c("h2", [_vm._v("Additional Services")]),
              _c("p", [_vm._v("- Free assistance for setting up your data")]),
              _c("p", [
                _vm._v(
                  "- Onsite consultation available- please contact (443)-509-1389 "
                ),
              ]),
              _c("p", [
                _vm._v(
                  "- More features to be announced in the future, check for updates!"
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }